import GnbCheckerBoardMenuContainer from './GnbCheckerBoardMenuContainer';

export default GnbCheckerBoardMenuContainer;
